module.exports = __webpack_public_path__ + "static/mg_logo-c8173c2413c5553bf22ed19e1de96930.png";